import { useEffect } from 'react';

const SESSION_DURATION = 60 * 60 * 1000; // 15 minutes

const useSlidingSession = () => {
    useEffect(() => {
        const updateSessionExpiry = () => {
            const token = localStorage.getItem('token');
            if (token) {
                const newExpiry = Date.now() + SESSION_DURATION;
                localStorage.setItem('session_expiry', newExpiry.toString());
               // console.log("🔥 Session extended:", new Date(newExpiry));
            }
        };

        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
        events.forEach(event => window.addEventListener(event, updateSessionExpiry));

        updateSessionExpiry(); // run on first mount

        return () => {
            events.forEach(event => window.removeEventListener(event, updateSessionExpiry));
        };
    }, []);
};

export default useSlidingSession;
